import { KyrgyzstanWebviewOwnerApi } from 'shared/api/kyrgyzstan/webview-owner'

import { mapOwnerOrderToObjectBooking } from './map-owner-order-to-object-booking'
import type { ObjectBooking } from './types'

interface FetchObjectBookingsPageParams {
  activeOnly: boolean
  page: number
  pageSize: number
  signal?: AbortSignal
}

export interface ObjectBookingsPageResult {
  items: ObjectBooking[]
  page: number
  totalPages: number
}

export const fetchObjectBookingsPage = async ({
  activeOnly,
  page,
  pageSize,
  signal,
}: FetchObjectBookingsPageParams): Promise<ObjectBookingsPageResult> => {
  const { data } = await KyrgyzstanWebviewOwnerApi.getOrders(
    {
      page,
      page_size: pageSize,
      is_booking: true,
      active_only: activeOnly,
    },
    signal,
  )

  return {
    items: data.data.map(mapOwnerOrderToObjectBooking),
    page: data.page,
    totalPages: data.total_pages || 1,
  }
}
